import React from "react";
import "./RenderImageBatches.css"

export default function RenderImageBatches(props){
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const imageTopicName = props?.imageTopic?.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())

   
  
  return(
    <>
        {/* {(props?.source && props?.exploreNextType !== "long" && props.index === 6) && (
  <div className="caption_link_container saved_badge main_action_button main_save_button get_caption_inside_image animate-in" 
 
  >
  <div className="caption-text">
    
   
    

    Use for Instagram <i className="fa-brands fa-instagram ig_color"></i>


  </div>

  </div>
)} */}


 
 
    
      {/* {(props?.source && props?.exploreNextType !== "long" && props.index === 0) && (
  <div className="caption_link_container saved_badge main_action_button main_save_button  explorenext_start_image animate-in full_text updated_postion" 
 
  >
  <div className={`caption-text ${isMobile ? 'mobile_caption' : 'full_text'}`}>   
  
 
    Tap to see more {imageTopicName} <i className="fa-solid fa-angle-right"></i>
  
  </div>

  </div>
)} */}
    </>
  )
}

//  {/* Get Caption  */}
//     {/* {captionText} */}
//     {/* Trending Today */}
//   {/* <i className="fa-solid fa-angle-right"></i> */}



  // {/* Get Caption  */}
  //   {/* {captionText} */}
  //   {/* Trending Today */}
  //   {/* Try this 🔥 */}
  //   {/* Use for Instagram <i className="fa-brands fa-instagram"></i> */}

  export function CreatorsBadge(props){
    if(!props.creatorsText) return
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    return(<>

      <div className="caption_link_container saved_badge main_action_button main_save_button  image_main_badge animate-in explorenext_start_image" 
 
  >
  <div className={`caption-text ${isMobile ? 'mobile_caption' : 'full_text'} `}>   
  
    {props.imageBlur ? `Explore more ${props.creatorsText}` : props.creatorsText} <i className="fa-solid fa-angle-right"></i>
  
  </div>

  </div>
    </>)
  }